module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.13/frontend/_next/static/images/AppGalleryText-2472cd41ba2203cf2ecca2c9fc97f9fe.svg";